<template>
    <span>
        <span style="display:none">
            <!-- 价格显示区域 -->
             <div class="deposit-timer" ref="timer" v-show="currentBook || isPresell || isPresell">
                <!--<dl class="deposit-timer-left" v-if="currentBook">-->
                    <!--<dt class="deposit-timer-price">-->
                        <!--<span class="name">{{isBook ? "定金" : "预售价"}}</span>-->
                        <!--<span class="yuan">Ks</span>-->
                        <!--<span class="integer">{{currentBook.downPayment|getInteger}}</span>-->
                        <!--<span class="pointer">.</span>-->
                        <!--<span class="decimal">{{currentBook.downPayment|getDecimal}}</span>-->
                    <!--</dt>-->
                <!--</dl>-->
                <dl class="deposit-timer-right">
                    <!--<dt class="timer-text">{{isBook ? "距支付定金结束" : "距预售活动结束"}}</dt>-->
                    <dd class="timer-upside" ref="countdown"></dd>
                </dl>
            </div>
            <!-- end 价格显示区域 -->
        </span>


        <div style="background:#fff">
                <!--<div v-if="isBook" class="detail-item" style="padding: 0" @click="showDialog = true ,showDialogFirst = false ">-->
                    <!--<dl class="deposit">-->
                        <!--<dt class="deposit-text">定金</dt>-->
                        <!--<dd class="deposit-price"><i>Ks</i><em>{{currentBook.downPayment|$convertPrice}}</em>({{currentBook.downTime|$convertDate}}截止)</dd>-->
                    <!--</dl>-->
                    <!--<dl class="deposit">-->
                        <!--<dt class="deposit-text">尾款</dt>-->
                        <!--<dd class="deposit-price"><i>Ks</i><em class="retainage">{{currentBook.finalPayment|$convertPrice}}</em>(定金支付后{{bookAutoEndTime}}小时之内)</dd>-->
                    <!--</dl>-->
                    <!--<dl class="deposit">-->
                        <!--<a href="javascript:;">-->
                            <!--<dt class="deposit-text">流程</dt>-->
                            <!--<dd class="deposit-rule"-->
                                <!--@click="showDialog = true ,showDialogFirst = false ">1.付定金 - 2.付尾款 - 3.发货<b></b></dd>-->
                        <!--</a>-->
                    <!--</dl>-->
                <!--</div>-->

                <div v-if="isPresell" class="detail-item" style="padding: 0" @click="showDialog = true ,showDialogFirst = false ">
                    <dl class="deposit">
                        <!--<dt class="deposit-text">预售</dt>-->
                        <!--<dd class="deposit-price"><i>Ks</i><em class="retainage">{{currentBook.finalPayment|$convertPrice}}</em>(付款后逾{{currentBook.downTime|getDayOnly|$convertDate}}日发货)</dd>-->
                        <dd class="deposit-price"><em class="retainage">付款后逾{{currentBook.downTime|getDayOnly|$convertDate}}发货</em><i></i></dd>
                    </dl>
                    <!--<dl class="deposit">-->
                        <!--<a href="javascript:;">-->
                            <!--<dt class="deposit-text">流程</dt>-->
                            <!--<dd class="deposit-rule">1.付款 - 2.发货<b></b></dd>-->
                        <!--</a>-->
                    <!--</dl>-->
                </div>


        </div>
        <!-- 弹出框 -->
        <transition name="ncbottom">
            <div class="nctouch-bottom-mask mask-show" v-show="showDialog"  ref="mash">
                <div class="nctouch-bottom-mask-bg" @click="showDialog = false , showDialogFirst= false" @touchmove="excludeTouch"></div>
                <div class="nctouch-bottom-mask-block">
                    <div class="nctouch-bottom-mask-top" @touchmove="excludeTouch">
                        <div class="close" @touchmove="excludeTouch">定金规则
                            <i class="closed" @click="showDialog = false , showDialogFirst= false"></i>
                            <i class="right" style="display: none;"></i>
                        </div>
                    </div>
                    <div class="deposit-rule" ref="scroll">
                        <ul v-html="bootRuleText"></ul>
                    </div>
                </div>
            </div>
        </transition>
    </span>
</template>
<script>
    // js 区域
    export default {
        //外部传入参数
        props: {
            // 当前sku信息
            currentGoodsInfo: {
                type: Object,
                required: true
            },
            //当前预售信息
            currentBook: {
                required: false
            },
            //定金支付时间
            bookAutoEndTime: {
                type: null,
                required: true
            },
            //预售规则
            bookRule: {
                type: String,
                required: true
            },
            //价格显示区域
            showPriceElement: {
                type: String,
                required: true
            }

        },
        /*
         * 自身数据,一定要一个function
         */
        data() {
            return {
                showDialog: false,
                showDialogFirst: true,
                scrollInstance: null
            }
        },
        /**
         * 计算属性
         */
        computed: {
            bootRuleText :function () {
                return this.bookRule.replace('{$bookAutoEndTime}' , this.bookAutoEndTime)
            },
            /**
             * 结束时间
             */
            endTimeUnix: function () {

                var _endTime = (new Date(this.currentBook.downTime.replace(/-+/g, "/"))).getTime(),
                        nowTime = Date.parse(new Date()),
                        result = (_endTime - nowTime) / 1000
                        ;
                return result > 0 ? result : 0;
            },
            /**
             * 是否是定金预售
             */
            isBook: function () {
                return this.isUsable == 1 && this.currentBook && this.currentGoodsInfo.promotionType == 3
            },
            /**
             是否是全款预售
             */
            isPresell: function () {
                return this.isUsable == 1 && this.currentBook && this.currentGoodsInfo.promotionType == 2
            },
            /**
             * 标识是否有活动
             */
            isUsable: function () {
                return getUsable(this.currentGoodsInfo)
            }
        },

        /**
         * 监听属性变动
         */
        watch: {
            showDialog: function (value) {
                var self = this;
                if (value) {
                    this.$nextTick(function () {
                        if (!self.scrollInstance) {
                            self.scrollInstance = new IScroll(self.$refs.scroll, {
                                scrollX: false,
                                scrollY: true,
                                click: false
                            });
                        } else {
                            self.scrollInstance.refresh()
                        }
                    })
                }
            }
        },
        /**
         * 过滤器
         */
        filters: {
            /**
             * 只获取日期
             */
            getDayOnly: function (value) {
                return value.split(" ")[0];
            },
            /**
             *  获取价格的整数
             */
            getInteger: function (value) {
                var price = Nc.priceFormat(value);
                return price.split(".")[0]
            },
            /**
             * 获取价格的小叔
             */
            getDecimal: function (value) {
                var price =  Nc.priceFormat(value);
                return price.split(".")[1]
            }
        },

        mounted() {

            var self = this,

                    $body, $target, $timer, $mash;

            //移动元素
//            if (this.isBook || this.isPresell) {
                $timer = this.$refs.timer;
                $mash = this.$refs.mash;
                $body = document.getElementsByTagName("body")[0];
                $body.appendChild($mash);
                //移动价格显示
                $target = document.querySelectorAll(this.showPriceElement);
                if ($target.length) {
                    $target[0].appendChild($timer)
                }
//            }
            //添加倒计时
            this.refreshCountDown()
            //发送事件
//            this.$emit("updated")
        },
        updated() {

            this.$emit("updated")
        },

        /**
         * 自定义方法
         */
        methods: {
            //刷新倒计时
            refreshCountDown: function () {
                if(!this.currentBook) return ;
                var _endTimeUnix = this.endTimeUnix;
                if (_endTimeUnix == 0)  return
                    $(this.$refs.countdown).ncCountDown({
                        time: _endTimeUnix,
                        cndays: "timer-day",
                        cnminutes: "timer-hours",
                        cnallHours: 'timer-hours',
                        cnhours: 'timer-hours',
                        cnseconds: 'timer-hours',
                        unitDay: "<i>:</i>",
                        unitHour: "<em>:</em>",
                        unitMinute: "<em>:</em>",
                        unitSecond: "",
                        warp: "span",
                        hideDay: false,
                        end: function () {
                            Nc.go();
                        }
                    });

            },
            //去除无关的touch事件
            excludeTouch: function (event) {
                event.preventDefault();
                return false;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/goods-book/goods-book.vue